import React from 'react';
import BackButton from '../components/BackButton';
import ChemicalTrail from '../components/ChemicalTrail';

function ChemicalTrailPage() {
  return (
    <>
      <BackButton />
      <ChemicalTrail />
    </>
  );
}

export default ChemicalTrailPage;
